import iconNotFound from '../../assets/image-emptyResult.png'

const EmptyResultSection = ({ message }) => (

  <div className="w-full rounded-md border border-gray-200 bg-gray-50 p-4 text-center text-gray-600">

    <img  style={{ height: '11rem', width: '11rem'}} 

      src={iconNotFound} alt="Sem resultados" className="mx-auto h-16 w-16 opacity-70" />
    <div className="mt-2">{message ?? 'Não foram encontrados dados'}</div>

  </div>

)


export default EmptyResultSection